import React from "react";
import { EmptyState } from "../State";

export function CommentsPanel({ comments }) {
  if (!comments || !comments.length)
    return (
      <EmptyState
        icon="message"
        title="No comments"
        subtitle="No comments on this ticket yet."
      />
    );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {comments.map((c) => (
        <div
          key={c.id}
          style={{
            background: c.is_internal ? "#FFFBEB" : "#F8FAFC",
            border: `1px solid ${c.is_internal ? "#FDE68A" : "#E2E8F0"}`,
            borderRadius: 8,
            padding: "10px 12px",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 7,
              alignItems: "center",
              marginBottom: 5,
            }}
          >
            <span
              style={{
                fontSize: 10,
                background: "#E5E7EB",
                padding: "2px 7px",
                borderRadius: 9,
                color: "#374151",
                fontWeight: 600,
              }}
            >
              {c.author_type}
            </span>
            {c.is_internal && (
              <span
                style={{
                  fontSize: 10,
                  background: "#FEF3C7",
                  color: "#B45309",
                  padding: "2px 7px",
                  borderRadius: 9,
                  fontWeight: 600,
                }}
              >
                Internal
              </span>
            )}
            {c.created_at && (
              <span
                style={{ fontSize: 10, color: "#9CA3AF", marginLeft: "auto" }}
              >
                {new Date(c.created_at).toLocaleString()}
              </span>
            )}
          </div>
          <p
            style={{
              margin: 0,
              fontSize: 12,
              color: "#1E293B",
              lineHeight: 1.6,
            }}
          >
            {c.body}
          </p>
        </div>
      ))}
    </div>
  );
}

export default CommentsPanel;
